import { useCallback } from 'react';

import { showModal } from 'modal.react.js';
import pluralize from 'pluralize';
import { useDispatch } from 'react-redux';

import area from 'components/shared/GlobalModalArea/area';
import { deleteTripEventsAction } from 'store/itinerariesItem';

import { IDeleteDialogProps } from './types';

import DeleteDialog from './index';

export async function deleteTripEvents(ids: number[]) {
  await showModal(area, (res, rej) => <DeleteDialog res={res} rej={rej} ids={ids} />);
}

export function useDeleteDialog({ rej, ids }: IDeleteDialogProps) {
  const dispatch = useDispatch();

  const handleDelete = useCallback(() => {
    dispatch(deleteTripEventsAction({ ids }));

    // TOFIX: AlertModal is using res/rej incorrectly.
    // It should be calling res when the user clicks on the confirm button
    // and rej when the user clicks on the close button.
    // This is a temporary solution that switches the res/rej logic.
    rej('deleted');
  }, [rej, ids, dispatch]);

  const config = {
    headerText: `Delete ${pluralize('Event', ids.length)}`,
    bodyText: `Are you sure you want to delete ${ids.length === 1 ? 'this event' : 'these events'}?`,
    onAccept: handleDelete,
    closeButtonText: 'Cancel',
    confirmButtonText: 'Yes, Delete',
  };

  return { config };
}
